import { GetBaseOptions } from 'api/requestsTypes/get'
import { LMCRequest as LmcRequest } from './types'
import { GoalListResponse } from '@lmc/ts-common'
import { getJSON } from 'common/services/api'

const list: LmcRequest<
  { result: GoalListResponse[] },
  { anyStatus: boolean },
  GetBaseOptions
> = (residentId) => getJSON({ url: `/api/list/residents/${residentId}/goals` })

const fetch: LmcRequest<
  { result: GoalListResponse },
  { residentID: string; goalID: string },
  GetBaseOptions
> = ({ params }) => {
  return getJSON({
    url: `/api/list/residents/${params.residentID}/goals/${params.goalID}`,
  })
}

export const goalsRequests = {
  list,
  fetch,
}
